import styled, { css } from "styled-components";

export const Title = styled.h1`
  ${({ theme }) => css`
    text-align: center;
    color: ${theme.colors.dark_background};
    font-size: 1.3125rem;
    font-weight: 600;

    margin-bottom: 2.5rem;
  `}
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
`;

export const ContainerBanks = styled.div`
  margin-bottom: 2rem;

  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const BankItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;

  img {
    width: 3rem;
    height: 3rem;
  }

  div {
    strong {
      font-size: 1.12rem;
      font-weight: 500;
      line-height: 1.5rem;
    }

    p {
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5rem;
      margin-top: -0.4rem;
    }
  }
`;

export const WrapperButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin-top: 3.6rem;
`;
